import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import { useNavigate } from 'react-router-dom'; // Use useNavigate from react-router-dom
import Footer from './Footer.js';  // Import Footer component
import { BASE_URL } from "./Constants.js";
import { BASE_URL1 } from "./Constants.js";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const Manage_User = () => {
  const [showModal, setShowModal] = useState(false);
  const [showStockError, setShowStockError] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState('');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [areaFilter, setAreaFilter] = useState('');
  const [users, setUsers] = useState([]); // State to store users data
  const [user, setUser] = useState([]); // State to store user data
  const [departments, setDepartments] = useState([]);
  const [userType, setUserType] = useState('');
  const [loading, setLoading] = useState(true); // State for loading indicator
  const [error, setError] = useState(null); // State for error handling
  const [dressTypes, setDressTypes] = useState([]); // State to store dress types
  const [dressSizes, setDressSizes] = useState([]); // State to store dress sizes
  const [dressColors, setDressColors] = useState([]); // State to store dress colors

  const [searchQuery, setSearchQuery] = useState(''); // Search query state
  const [departmentFilter, setDepartmentFilter] = useState(''); // Department filter state
  const [Locations, setLocations] = useState([]);

  const [locationFilter, setLocationFilter] = useState(''); // Location filter state
  const [genderFilter, setGenderFilter] = useState(''); // Gender filter state

  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [usersPerPage] = useState(10); // Users per page for pagination

  const navigate = useNavigate(); // Use useNavigate for page navigation
  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };
  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleUserTypeChange = (e) => {
    const selectedType = e.target.value;
    setUserType(selectedType);

    if (selectedType === 'employee') {
      navigate('/manage_employee');
    } else if (selectedType === 'candidate') {
      navigate('/manage_candidates');
    }
  };

  // Handle department filter change
  const handleDepartmentFilterChange = (e) => {
    setDepartmentFilter(e.target.value);
  };

  // Handle location filter change
  const handleLocationFilterChange = (e) => {
    setLocationFilter(e.target.value);
  };

  // Handle gender filter change
  const handleGenderFilterChange = (e) => {
    setGenderFilter(e.target.value);
  };

  // Handle page change for pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const profile_details = sessionStorage.getItem('userProfile');
  const admin_emp_code = sessionStorage.getItem('userEmpCode');
  console.log("admin_emp_code", admin_emp_code);

  console.log("session_values", profile_details.emp_code);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setError('No token found!');
        setLoading(false);
        return;
      }

      try {
        // Fetch profile to check if the user is an admin
        const profileResponse = await fetch(`${BASE_URL}profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const profileData = await profileResponse.json();
        if (profileData && profileData.profile) {
          setUser(profileData.profile.is_uniform_access_given); // Safely access is_admin if profile exists
        } else {
          setError('Profile data not found');
        }

        // Fetch users data
        const usersResponse = await fetch(`${BASE_URL}candidates_test`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const usersData = await usersResponse.json();
        if (usersData && usersData.employees && Array.isArray(usersData.employees)) {
          setUsers(usersData.employees);
        } else {
          setError('No users found');
        }

        // Fetch dress types
        const dressTypesResponse = await fetch(`${BASE_URL}dress_types`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const dressTypesData = await dressTypesResponse.json();
        if (dressTypesData && dressTypesData.dressTypes) {
          const activeDressTypes = dressTypesData.dressTypes.filter(type => type.status === 'A');
          setDressTypes(activeDressTypes);
        }

        // Fetch dress sizes
        const dressSizesResponse = await fetch(`${BASE_URL}dress_sizes`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const dressSizesData = await dressSizesResponse.json();
        if (dressSizesData && dressSizesData.dressSizes) {
          const activeDressSizes = dressSizesData.dressSizes.filter(size => size.status === 'A');
          setDressSizes(activeDressSizes);
        }

        // Fetch dress colors
        const dressColorsResponse = await fetch(`${BASE_URL}dress_colors`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const dressColorsData = await dressColorsResponse.json();
        if (dressColorsData && dressColorsData.dressColors) {
          const activeDressColors = dressColorsData.dressColors.filter(color => color.status === 'A');
          setDressColors(activeDressColors);
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures this effect runs once on component mount

  useEffect(() => {
    const fetchDepts = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}get_depts`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch departments');
        }

        const data = await response.json();
        if (data && data.status && Array.isArray(data.data)) {
          setDepartments(data.data); // Save the department list
        } else {
          setError('No departments found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDepts();
  }, []);

  useEffect(() => {
    const fetchLocs = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}get_locs`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch departments');
        }

        const data = await response.json();
        if (data && data.status && Array.isArray(data.data)) {
          setLocations(data.data); // Save the department list
        } else {
          setError('No departments found');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLocs();
  }, []);


  // Function to handle adding a user (navigate to the "Add Candidate" page)
  const handleAddUser = () => {
    navigate('/add_employee');
  };

  // Function to get the dress type name by ID
  const getDressTypeName = (id) => {
    const dressType = dressTypes.find(type => type.id === id);
    return dressType ? dressType.dress_type : 'Unknown';
  };

  // Function to get the dress size name by ID
  const getDressSizeName = (id) => {
    const dressSize = dressSizes.find(size => size.id === id);
    return dressSize ? dressSize.dress_size : 'Unknown';
  };

  // Function to get the dress color name by ID
  const getDressColorName = (id) => {
    const dressColor = dressColors.find(color => color.id === id);
    return dressColor ? dressColor.dress_color : 'Unknown';
  };

  // Filter users based on search and filter criteria
  const filteredUsers = users.filter((user) => {
    const lowerQuery = searchQuery?.toLowerCase() || '';

    // Convert user.id to string safely
    const idMatches = user.id?.toString().includes(lowerQuery);
    const nameMatches = user.candidate_name?.toLowerCase().includes(lowerQuery);
    const registrationTypeMatches = user.registration_type?.toLowerCase().includes(lowerQuery);
    const paymentDateMatches = user.payment_date?.toLowerCase().includes(lowerQuery);

    const searchMatches =
      idMatches ||
      nameMatches ||
      registrationTypeMatches ||
      paymentDateMatches;

    const departmentMatches = !departmentFilter || user.department === departmentFilter;
    const locationMatches = !locationFilter || user.location === locationFilter;
    const genderMatches = !genderFilter || user.gender === genderFilter;
    const areaMatches = !areaFilter || user.area === areaFilter;

    return searchMatches && departmentMatches && locationMatches && genderMatches && areaMatches;
  });


  // Pagination logic
  const indexOfLastUser = currentPage * itemsPerPage;
  const indexOfFirstUser = indexOfLastUser - itemsPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredUsers.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const handleExcelExport = () => {
    // Prepare data from currentUsers
    const exportData = currentUsers.map(user => ({
      ID: user.id,
      Date: user.created_on ? user.created_on.substring(0, 10) : 'Not provided',
      Name: user.candidate_name,
      Gender: user.gender,
      Department: user.department,
      Area: user.area,
      'Registration Type': user.registration_type,
      'Payment Mode': user.payment_mode,
      'Payment Date': user.payment_date,
      'Payment Status': user.payment_status,
      'Uniform Type': user.uniform_type,
      'Uniform Size': user.uniform_size,
      'Uniform Color': user.uniform_color,
      'Uniform Qty': user.uniform_qty,
      Cost: user.cost
    }));

    // Create worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');

    // Convert workbook to binary and trigger download
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const fileData = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(fileData, 'Uniform_Payment_Report.xlsx');
  };


  return (
    <div className='page-wrapper'>
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div
        className="page-container"
        style={{
          marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '250px' : '0',
          transition: 'margin-left 0.3s ease',
        }}
      >
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="row">
                {/* <div className="d-flex align-items-center mb-3">
                  <label className="mr-3 font-weight-bold">Select Type:</label>
                  <div className="form-check mr-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="userType"
                      id="employeeRadio"
                      value="employee"
                      checked={userType === 'employee'}
                      onChange={handleUserTypeChange}
                    />
                    <label className="form-check-label" htmlFor="employeeRadio">
                      Employee
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="userType"
                      id="candidateRadio"
                      value="candidate"
                      checked={userType === 'candidate'}
                      onChange={handleUserTypeChange}
                    />
                    <label className="form-check-label" htmlFor="candidateRadio">
                      Candidate
                    </label>
                  </div>
                </div> */}
                <div className="col-lg-12">
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                    {/* Left side: Issue Uniform Button */}
                    <button className="btn btn-primary" onClick={handleAddUser}>
                      Issue Uniform
                    </button>

                    {/* Middle: Excel Button */}
                    <div>
                      <button className="btn btn-success" onClick={handleExcelExport}>
                        Excel Report
                      </button>
                    </div>

                    {/* Right side: Items per page selector */}
                    <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                      <label htmlFor="itemsPerPage" className="mb-0">Items per page:</label>
                      <select
                        id="itemsPerPage"
                        className="form-select"
                        style={{ width: '100px' }}
                        value={itemsPerPage}
                        onChange={(e) => {
                          setItemsPerPage(Number(e.target.value));
                          setCurrentPage(1); // Reset to page 1
                        }}
                      >
                        <option value={10}>10</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                    </div>
                  </div>


                  {/* Search and Filter Controls */}
                  <div className="d-flex justify-content-between mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by name"
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                    <select
                      className="form-control ml-2"
                      value={departmentFilter}
                      onChange={handleDepartmentFilterChange}
                    >
                      <option value="">All Departments</option>
                      {departments.map((dept, index) => (
                        <option key={index} value={dept.EREC_APVC_Dept}>
                          {dept.EREC_APVC_Dept}
                        </option>
                      ))}
                    </select>
                    <select
                      className="form-control ml-2"
                      value={areaFilter}
                      onChange={(e) => setAreaFilter(e.target.value)}
                    >
                      <option value="">All Areas</option>
                      {[...new Set(users.map(user => user.area))].map((area, index) => (
                        <option key={index} value={area}>
                          {area}
                        </option>
                      ))}
                    </select>
                    <select
                      className="form-control ml-2"
                      value={genderFilter}
                      onChange={handleGenderFilterChange}
                    >
                      <option value="">All Genders</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>

                  {/* User Table */}
                  <div className="table-responsive table--no-card m-b-30">
                    <table className="table table-bordered table-striped" style={{
                      fontSize: '0.85rem',
                      lineHeight: '1.5',
                    }}>
                      <thead>
                        <tr><th>#</th>
                          <th>Date of Paid</th>
                          <th>Name</th>
                          <th>Gender</th>
                          <th>Department</th>
                          <th>Location</th>
                          <th>User Type</th>
                          <th>Payment Mode</th>
                          <th>Payment Date</th>
                          <th>Payment Status</th>
                          <th>Area</th>
                          <th>Dress Type</th>
                          <th>Dress Size</th>
                          <th>Dress Color</th>
                          <th>Qty</th>
                          <th>Total Amount</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentUsers.map((user) => {
                          const encodedId = btoa(user.id.toString()); // Encode the user.id to base64
                          // Calculate if Return button should be shown
                          let showReturnButton = false;
                          if (user.payment_status === 'Approved' && user.delivery_status === 'N' && user.payment_date) {
                            const today = new Date();
                            const paymentDate = new Date(user.payment_date);
                            const diffInDays = (today - paymentDate) / (1000 * 60 * 60 * 24);
                            showReturnButton = diffInDays <= 7;
                          }
                          return (
                            <tr key={user.id}>
                              <td>{user.id}</td>
                              <td>{user.created_on ? user.created_on.substring(0, 10) : 'Not provided'}</td>

                              <td>{user.candidate_name}</td>
                              <td>{user.gender}</td>
                              <td>{user.department}</td>
                              <td>{user.location}</td>
                              <td>{user.registration_type}</td>
                              <td>{user.payment_mode}</td>
                              <td>{user.payment_date}</td>
                              <td>{user.payment_status}</td>
                              <td>{user.area}</td>
                              <td>{user.uniform_type}</td>
                              <td>{user.uniform_size}</td>
                              <td>{user.uniform_color}</td>
                              <td>{user.uniform_qty}</td>
                              <td className="text-right">{user.cost}</td>

                              <td className="d-flex align-items-center">
                                {/* Print Button */}
                                {user.payment_status === 'Approved' && (
                                  <a
                                    href={`/printk/${user.id}`}
                                    target="_blank"
                                    style={{ marginRight: "8px" }}
                                  >
                                    <button
                                      type="button"
                                      className="btn btn-success d-flex align-items-center justify-content-center"
                                      style={{ height: "38px", width: "40px" }}
                                      title="Print"
                                    >
                                      <i className="fas fa-print"></i>
                                    </button>
                                  </a>)}

                                {/* Pay Button - only if payment is pending */}
                                {/* {user.payment_status === 'Pending' && (
                                  <button
                                    type="button"
                                    className="btn btn-primary d-flex align-items-center justify-content-center"
                                    style={{ height: "38px", width: "40px" }}
                                    title="Pay Now"
                                    onClick={() => {
                                      const encodedId = btoa(user.id.toString());
                                      const encodedPaymentMode = btoa(user.payment_mode.toString());
                                      setPaymentUrl(`${BASE_URL1}payment/initiatePayment.php?id=${encodedId}&payment_type=${encodedPaymentMode}`);
                                      setShowModal(true);
                                    }}
                                  >
                                    <i className="fas fa-credit-card"></i>
                                  </button>
                                )} */}

                                {user.payment_status === 'Pending' && (
                                  <button
                                    type="button"
                                    className="btn btn-primary d-flex align-items-center justify-content-center"
                                    style={{ height: "38px", width: "40px" }}
                                    title="Pay Now"
                                    onClick={() => {
                                      
                                      if (Number(user.uniform_qty) <= Number(user.available_qty)) {
                                        
                                        const encodedId = btoa(user.id.toString());
                                        const encodedPaymentMode = btoa(user.payment_mode.toString());
                                        setPaymentUrl(`${BASE_URL1}payment/initiatePayment.php?id=${encodedId}&payment_type=${encodedPaymentMode}`);
                                        setShowModal(true);
                                      } else {
                                        setShowStockError(true); // Show stock error modal
                                      }
                                    }}
                                  >
                                    <i className="fas fa-credit-card"></i>
                                  </button>
                                )}
                                {user.payment_status === 'Approved' && user.delivery_status === 'N' && (
                                  <button
                                    type="button"
                                    className="btn btn-warning d-flex align-items-center justify-content-center"
                                    style={{ height: "38px", width: "40px" }}
                                    title="Delivery Status"
                                    onClick={async () => {
                                      try {
                                        const token = localStorage.getItem('authToken'); // if needed
                                        const response = await fetch(`${BASE_URL}create_otp`, {
                                          method: 'POST',
                                          headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': `Bearer ${token}`, // remove if not required
                                          },
                                          body: JSON.stringify({ id: user.id, name: user.candidate_name, mobile: user.mobile }),
                                        });

                                        const data = await response.json();
                                        if (data.status) {
                                          navigate(`/otp_screen/${user.id}`);

                                          // optionally update state or redirect
                                        } else {
                                          console.log("Failed to create OTP.");
                                        }
                                      } catch (err) {
                                        console.error("Error creating OTP:", err);
                                        console.log("Error while creating OTP.");
                                      }
                                    }}
                                  >
                                    <i className="fas fa-truck"></i>
                                  </button>
                                )}

                                {/* Return Button */}
                                {/* {showReturnButton && (
                                  
                                  <button
                                    type="button"
                                    className="btn btn-danger d-flex align-items-center justify-content-center"
                                    style={{ height: '38px', width: '40px', marginLeft: '8px' }}
                                    title="Return"
                                    // onClick={() => {
                                    //   console.log(`Return clicked for ID: ${user.id}`);
                                    //   // Optionally: navigate(`/return/${user.id}`) or call API
                                    // }}
                                    onClick={() => navigate(`/return_stock/${user.id}`)}
                                  >
                                    <i className="fas fa-undo-alt"></i>
                                  </button>
                                )} */}

                                {(() => {
                                  const isApproved = user?.payment_status === 'Approved';
                                  const trimmedEmpCode = String(admin_emp_code).trim();
                                  const allowed = ['110104', '108224'].includes(trimmedEmpCode);

                                  // Log everything for debugging
                                  console.log('🔍 [Return Button Check]', {
                                    payment_status: user?.payment_status,
                                    isApproved,
                                    admin_emp_code,
                                    trimmedEmpCode,
                                    isAllowed: allowed,
                                    showButton: isApproved && allowed,
                                  });

                                  return isApproved && allowed ? (
                                    <button
                                      type="button"
                                      className="btn btn-danger d-flex align-items-center justify-content-center"
                                      style={{ height: '38px', width: '40px', marginLeft: '8px' }}
                                      title="Return"
                                      onClick={() => navigate(`/return_stock/${user.id}`)}
                                    >
                                      <i className="fas fa-undo-alt"></i>
                                    </button>
                                  ) : null;
                                })()}



                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <nav className="pagination-container">
                    <ul className="pagination justify-content-center">
                      {/* Previous button with left arrow */}
                      {currentPage > 1 && (
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage - 1)}
                          >
                            &lt; {/* Left Arrow (Unicode) */}
                          </button>
                        </li>
                      )}

                      {/* Show limited page numbers (3 before and after the current page) */}
                      {pageNumbers
                        .filter((number) => number >= currentPage - 2 && number <= currentPage + 2)
                        .map((number) => (
                          <li
                            key={number}
                            className={`page-item ${currentPage === number ? 'active' : ''}`}
                          >
                            <button
                              className="page-link"
                              onClick={() => handlePageChange(number)}
                            >
                              {number}
                            </button>
                          </li>
                        ))}

                      {/* Next button with right arrow */}
                      {currentPage < pageNumbers.length && (
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(currentPage + 1)}
                          >
                            &gt; {/* Right Arrow (Unicode) */}
                          </button>
                        </li>
                      )}
                    </ul>
                  </nav>

                  {/* Total Pages Display */}
                  <div className="text-center mt-2">
                    <span>Page {currentPage} of {pageNumbers.length}</span>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Payment Link</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>You can use the link below to proceed with the payment:</p>
                <a href={paymentUrl} target="_blank" rel="noopener noreferrer">
                  {paymentUrl}
                </a>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
                <a
                  href={paymentUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                >
                  Open Payment
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {showStockError && (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Stock Error</h5>
                <button type="button" className="btn-close" onClick={() => setShowStockError(false)}></button>
              </div>
              <div className="modal-body">
                <p style={{ color: 'red', fontWeight: 'bold' }}>
                  Stock is not available for the selected uniform combination.
                </p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowStockError(false)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Manage_User;